<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { Roles } from '@/constants.ts'
import ParticipantsToolbar from './ParticipantsToolbar.vue'
import ParticipantsTable from './ParticipantsTable.vue'
import type { ParticipantsFilters } from './participantsFilters.ts'

definePage({ meta: { allowedRoles: [Roles.Admin, Roles.Manager] } })

const { t } = useI18n()

const search = ref('')
const searchDebounced = ref('')
let searchTimer: ReturnType<typeof setTimeout> | undefined
watch(search, (value) => {
  clearTimeout(searchTimer)
  searchTimer = setTimeout(() => {
    searchDebounced.value = value
  }, 300)
})

const eventId = ref<string | null>(null)
const returningOnly = ref(false)

const filters = computed<ParticipantsFilters>(() => ({
  search: searchDebounced.value.trim() || undefined,
  eventId: eventId.value || undefined,
  returningOnly: returningOnly.value || undefined,
}))
</script>

<template>
  <section class="flex flex-col gap-4 w-full">
    <h1 class="text-xl font-bold">{{ t('participants.title') }}</h1>
    <ParticipantsToolbar
      v-model:search="search"
      v-model:event-id="eventId"
      v-model:returning-only="returningOnly"
    />
    <ParticipantsTable :filters="filters" />
  </section>
</template>
